export const replaceURLParam = (search: string, param: string, newValue: string) => {
  const searchParams = new URLSearchParams(search)
  searchParams.set(param, newValue)
  return searchParams.toString()
}

export const deleteURLParam = (search: string, param: string) => {
  const searchParams = new URLSearchParams(search)
  searchParams.delete(param)
  return searchParams.toString()
}
